export class User{

    clientNumber!:number;
    userId!:number
    name!:string;        
    email!:string;
    password?:string;
    phone!:string;
    position!: string;
    accessType!:number
    dialCode!:number
}